import { AfterViewInit, Component, Input,Output, EventEmitter, OnDestroy, OnInit, forwardRef } from '@angular/core';
import { FormBuilder, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FileUploader } from 'ng2-file-upload';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { EventManager } from 'src/app/core';
import { Constant } from 'src/app/core/constant';
import { UploaderService } from 'src/app/shared/services/uploader.service';
import { environment } from 'src/environments/environment';
import { StringUtil } from '../../../../shared/util/string.util';
declare var $;
@Component({
  selector: 'app-custom-editor',
  templateUrl: './custom-editor.component.html',
  styleUrls: ['./custom-editor.component.scss'],
  providers: [
    {
       provide: NG_VALUE_ACCESSOR,
       useExisting: forwardRef(() => CustomEditorComponent),
       multi: true
    }
 ]
})
export class CustomEditorComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() title: string = 'Nội dung';
  @Input() content: string = '';
  @Input() isRequired: boolean = false;
  @Output() contentChange: EventEmitter<any> = new EventEmitter();
  @Output() result: EventEmitter<any> = new EventEmitter();
  subscriptions?: Subscription[] = [];
  uploader: FileUploader;
  positionPointer: number = 0;
  getIconBroadcast: string = 'get-icon-push-notification';
  isOpenIcon: boolean = false;
  isOpenLink: boolean = false;
  isOpenProduct: boolean = false;
  onChange: any = () => { };
  onTouched: any = () => { };
  emitChange$ = new Subject();
  constructor(
    public formBuilder: FormBuilder,
    public uploaderService: UploaderService,
    public eventManager: EventManager
  ) {
  }
  ngOnInit() {
    this.subscriptions = [
      this.eventManager.subscribe(this.getIconBroadcast, (res) => {
        let description = this.content;
        const value = description.substring(0, this.positionPointer) + res.content.value + description.substring(this.positionPointer);
        this.content = value;
        this.emitChange();
      }),
      this.eventManager.subscribe('add-content-custom-editor', (res) => {
        let description = this.content;
        const value = description.substring(0, this.positionPointer) + res.content.value + '\n' + description.substring(this.positionPointer);
        this.content = value;
        this.emitChange();
      }),
      this.eventManager.subscribe('ckeditor-image-upload', (res) => {
        const description = this.content;
        const value = description.substring(0, this.positionPointer) + `<image>${res.content.imagePath}</image>\n` + description.substring(this.positionPointer);
        this.content = value;
        this.emitChange();
      }),
      this.emitChange$.pipe(
        debounceTime(1000),
      ).subscribe((event)=> { return this.emitChange();}),
    ];
    this.uploader = this.uploaderService.initUploader(
      environment.urlUploadBackEnd + Constant.API_UPLOAD, 'ckeditor-image-upload', 'image', {fileSize: 5 * 1024 * 1024, pixelSize: 1000});
  }
  ngAfterViewInit(): void {
    $("#inputDescription").bind("click", (e) => {
      this.positionPointer = e.target.selectionStart ; 
    });
  }
  ngOnDestroy(): void {
    this.eventManager.destroys(this.subscriptions);
  }
  emitData() {
    return this.content;
  }
  openIcon() {
    if (this.isOpenIcon) {
      this.closeIcon();
      return;
    }
    this.eventManager.broadcast({
      name: 'open-icon',
      content: {}
    });
    this.isOpenIcon = true;
    this.closeLink();
    this.closeProduct();
  }
  closeIcon() {
    this.eventManager.broadcast({
      name: 'close-icon',
      content: {}
    });
    this.isOpenIcon = false;
  }
  openLink() {
    if (this.isOpenLink) {
      this.closeLink();
      return;
    }
    this.eventManager.broadcast({
      name: 'open-link',
      content: {}
    });
    this.isOpenLink = true;
    this.closeIcon();
    this.closeProduct();
  }
  closeLink() {
    this.eventManager.broadcast({
      name: 'close-link',
      content: {}
    });
    this.isOpenLink = false;
  }
  openProduct() {
    if (this.isOpenProduct) {
      this.closeProduct();
      return;
    }
    this.eventManager.broadcast({
      name: 'open-product',
      content: {}
    });
    this.isOpenProduct = true;
    this.closeLink();
    this.closeIcon();
  }
  closeProduct() {
    this.eventManager.broadcast({
      name: 'close-product',
      content: {}
    });
    this.isOpenProduct = false;
  }
  addBold() {
    const selection: any = this.getInputSelection($('#inputDescription'));
    const description = this.content;
    const value = description.substring(0, selection.selectionStart) + `<bold>${selection.text}</bold>\n` + description.substring(selection.selectionEnd);
    this.content = value;
    this.emitChange();
    this.closeIcon();
    this.closeLink();
  }
  addImage() {
    $('#fileInputEditor').click();
    this.closeIcon();
    this.closeLink();
  }
  changeEditor(dataChange) {
    this.positionPointer = StringUtil.checkPositionDifferent(this.content, dataChange);
    this.emitChange$.next(true);
  }
  emitChange() {
    this.contentChange.emit(this.content);
    this.onChange(this.content);
  }
  
  getInputSelection(elem) {
    if(typeof elem != "undefined"){
      var s = elem[0].selectionStart;
      var e = elem[0].selectionEnd;
      return {
        selectionStart: s,
        selectionEnd: e,
        text: elem.val().substring(s, e)
      }
    }
    else{
      return null;
    }
  }
  writeValue(currentValue: any): void {
    this.content = currentValue;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
